module.exports = __webpack_public_path__ + "img/06_ihp.53240033.jpg";